import { getTalkDetails, getProgram, getWorkshopProgram } from '../../../utils/services';

export const TRACK_SELECT = 'TRACK_SELECT';
export const FETCH_TALKS_SUCCESS = 'FETCH_TALKS_SUCCESS';
export const FETCH_PROGRAM_REQUEST = 'FETCH_PROGRAM_REQUEST';
export const FETCH_TIMESLOTS_SUCCESS = 'FETCH_TIMESLOTS_SUCCESS';
export const FETCH_WORKSHOP_TIMESLOTS_SUCCESS = 'FETCH_WORKSHOP_TIMESLOTS_SUCCESS';

const fetchProgramRequest = () => ({
    type: FETCH_PROGRAM_REQUEST
});

export const fetchTalksSuccess = payload => ({
    type: FETCH_TALKS_SUCCESS,
    payload
});

export const trackSelect = payload => ({
    type: TRACK_SELECT,
    payload
});

export const fetchTalkDetails = id => async dispatch => {
    dispatch(fetchProgramRequest());
    try {
        const data = await getTalkDetails(id);
        dispatch(fetchTalksSuccess(data.talks));
        dispatch({
            type: 'FETCH_SPEAKERS_SUCCESS',
            payload: data.speakers
        });
    } catch (error) {
        dispatch(fetchTalksSuccess([]));
    }
};

export const loadProgram = () => async dispatch => {
    dispatch(fetchProgramRequest());
    try {
        const data = await getProgram();
        dispatch({
            type: 'FETCH_SPEAKERS_SUCCESS',
            payload: data.speakers
        });
        dispatch(fetchTalksSuccess(data.talks));
        dispatch({
            type: 'FETCH_TIMESLOTS_SUCCESS',
            payload: data.program
        });
    } catch (error) {
        dispatch(fetchTalksSuccess([]));
    }
};

export const loadWorkshopProgram = () => async dispatch => {
    dispatch(fetchProgramRequest());
    try {
        const data = await getWorkshopProgram();
        dispatch({
            type: 'FETCH_SPEAKERS_SUCCESS',
            payload: data.speakers
        });
        dispatch(fetchTalksSuccess(data.workshops));
        dispatch({
            type: 'FETCH_WORKSHOP_TIMESLOTS_SUCCESS',
            payload: data.workshopProgram
        });
    } catch (error) {
        dispatch(fetchTalksSuccess([]));
    }
};
